export const TYPES = {
  ELAVATED: "elevated",
  FLAT: "flat"
};

export const LAYOUTS = {
  CIRCLE: "circle",
  ROUNDED: "rounded"
};

